import { create } from 'zustand';
import axios from 'axios';
import { authHeaders } from 'actions';
import Routes from 'utils/routes.js.erb';

const useOrganizationSearch = create((set, get) => ({
  searchTerm: '',
  activeQuery: null,
  isSearching: false,
  results: null,

  setSearchTerm: (term) => set({ searchTerm: term }),

  submitSearch: async (term) => {
    const trimmed = term.trim();
    if (!trimmed) {
      get().clearSearch();
      return;
    }
    set({ isSearching: true, activeQuery: trimmed });
    try {
      const response = await axios.get(
        Routes.api_dashboard_administration_organizations_search_path(),
        { headers: authHeaders(), params: { q: trimmed } }
      );
      const d = response.data;
      const toSet = (...arrays) => new Set(arrays.flat().map(Number));
      set({
        results: {
          matchedGroupIds:    toSet(d.matched_group_ids),
          matchedSubgroupIds: toSet(d.matched_subgroup_ids),
          matchedCohortIds:   toSet(d.matched_cohort_ids),
          ancestorGroupIds:   toSet(d.ancestor_group_ids),
          ancestorSubgroupIds: toSet(d.ancestor_subgroup_ids),
          visibleGroupIds:    toSet(d.matched_group_ids, d.ancestor_group_ids),
          visibleSubgroupIds: toSet(d.matched_subgroup_ids, d.ancestor_subgroup_ids, d.descendant_subgroup_ids),
          visibleCohortIds:   toSet(d.matched_cohort_ids, d.descendant_cohort_ids),
        },
        isSearching: false,
      });
    } catch {
      set({ isSearching: false });
    }
  },

  clearSearch: () => set({
    searchTerm: '',
    activeQuery: null,
    isSearching: false,
    results: null,
  }),
}));

export default useOrganizationSearch;
